import { render, staticRenderFns } from "./OnChat.vue?vue&type=template&id=91303060&scoped=true&"
import script from "./OnChat.vue?vue&type=script&lang=js&"
export * from "./OnChat.vue?vue&type=script&lang=js&"
import style0 from "./OnChat.vue?vue&type=style&index=0&id=91303060&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91303060",
  null
  
)

export default component.exports